import { render, staticRenderFns } from "./studentfiles.vue?vue&type=template&id=6e62a24e&scoped=true&"
import script from "./studentfiles.vue?vue&type=script&lang=js&"
export * from "./studentfiles.vue?vue&type=script&lang=js&"
import style0 from "./studentfiles.vue?vue&type=style&index=0&id=6e62a24e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62a24e",
  null
  
)

export default component.exports